import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import HomepageSlidersApi from 'libs/api/website/homepageSliders';

const useSingleHomepageSlide = () => {
  const { id: routeId } = useParams();
  const [singleItem, setSingleItem] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!routeId) {
      return;
    }

    let cancelled = false;

    (async () => {
      setLoading(true);
      try {
        const response = await HomepageSlidersApi.show(routeId);
        const responseData = response.data;
        const slide =
          responseData?.success && responseData?.homepage_slide
            ? responseData.homepage_slide
            : responseData?.homepage_slide;

        if (!cancelled) {
          setSingleItem(slide || {});
        }
      } catch {
        if (!cancelled) {
          setSingleItem({});
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [routeId]);

  const viewItem = useMemo(
    () => ({
      ...singleItem,
      id: singleItem?.id || routeId,
    }),
    [singleItem, routeId],
  );

  return {
    singleItem: viewItem,
    loading,
  };
};

export default useSingleHomepageSlide;
